import JSCookie from 'js-cookie'

const sessionPrefix = process.env.VUE_APP_SESSION_PREFIX
const tokenCookieName = `${sessionPrefix}:token`
const langCookieName = `${sessionPrefix}:lang`

export const TokenSession = {
    set: (token) => {
        const value = typeof token === 'string' ? token : JSON.stringify(token)
        return JSCookie.set(tokenCookieName, value, { secure: true })
    },
    unset: () => JSCookie.remove(tokenCookieName),
    get: () => {
        const token = JSCookie.get(tokenCookieName)
        if (!token) return null
        if (typeof token === 'object') return token
        try {
            return JSON.parse(token)
        } catch (e) {
            // Backward/forward compatibility: if it's not JSON, treat as raw string
            return token
        }
    },
    formatToken: (tokenLike) => {
        if (!tokenLike) return { type: 'Bearer', token: undefined, refreshToken: undefined }

        if (typeof tokenLike === 'string') {
            return { type: 'Bearer', token: tokenLike, refreshToken: undefined }
        }

        // Accept both shapes:
        // - our own: { type, token, refreshToken }
        // - keycloak-js instance: { token, refreshToken }
        // - legacy: { token: { token, refreshToken }, type }
        const nestedToken = tokenLike?.token && typeof tokenLike.token === 'object' ? tokenLike.token : null

        return {
            type: tokenLike.type || 'Bearer',
            token: typeof tokenLike.token === 'string' ? tokenLike.token : nestedToken?.token,
            refreshToken: tokenLike.refreshToken || nestedToken?.refreshToken,
        }
    },
}

export const LangSession = {
    set: (token) => JSCookie.set(langCookieName, token, { secure: true }),
    unset: () => JSCookie.remove(langCookieName),
    get: () => JSCookie.get(langCookieName),
}

export default {
    Token: TokenSession,
    Lang: LangSession,
}
